import {lookupWordByUid} from '../index';
export default (state, external) => {
	return lookupWordByUid(state, `exu${external}`);
}
